import { render, staticRenderFns } from "./PrizeDetailModal2020.vue?vue&type=template&id=dda3b1e4&"
import script from "./PrizeDetailModal2020.vue?vue&type=script&lang=js&"
export * from "./PrizeDetailModal2020.vue?vue&type=script&lang=js&"
import style0 from "./PrizeDetailModal2020.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports